import React from 'react';
import { initPlanet } from './planetEngine';

const BLOCKS =
  '.main-page-header, .main-page-statCard, .main-page-ordersButton, button, a, [role="button"]';
const MODAL = '.main-page-modalOverlay, [role="dialog"], [aria-modal="true"]';

// Fixed, non-interactive canvas layer. Render it as a sibling OUTSIDE the
// scroll container (.main-page-mobile). `rootRef` = dashboard root element.
function PlanetBackground({ rootRef }) {
  const canvasRef = React.useRef(null);

  React.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !canvas.getContext) return undefined;
    const root = rootRef?.current || document.body;
    const content = root.querySelector('.main-page-content') || root;
    const planet = initPlanet(canvas, { root, observe: content, blockSelector: BLOCKS });

    // Re-measure on DOM changes inside the page ("еще" expand, stats loaded);
    // pause while any modal (BranchPicker portals into body) is open.
    let modalOpen = false;
    const checkModal = () => {
      const open = !!document.querySelector(MODAL);
      if (open !== modalOpen) {
        modalOpen = open;
        if (open) planet.pause(); else planet.resume();
      }
    };
    const contentMo = new MutationObserver(() => planet.remeasure());
    contentMo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'class'] });
    const bodyMo = new MutationObserver(checkModal);
    bodyMo.observe(document.body, { childList: true });
    // Repaint the canvas with the matching palette when the theme flips.
    const themeMo = new MutationObserver(() => planet.refreshTheme());
    themeMo.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    checkModal();

    return () => {
      contentMo.disconnect();
      bodyMo.disconnect();
      themeMo.disconnect();
      planet.destroy();
    };
  }, [rootRef]);

  return <canvas ref={canvasRef} className="planet-background" aria-hidden="true" />;
}

export default React.memo(PlanetBackground);
